import RippleManagerClass from "./RippleManagerClass";
import Util from "../../libs/util/Util";
import PartsManagerClass from "./PartsManagerClass";
import BaseClass from "../../libs/base/BaseClass";

/**
 * 全てのページクラスの元となるクラス
 */
export default class ParentPageBaseClass extends BaseClass{
    constructor(_target){
        super();
        this.name = "ParentPageBaseClass";

        this.target = _target;

        this.isBreackPointCheckFirst = true;

        this.isBreakpoint = (Util.getWindowSize().w <= Util.BREAK_POINT);

        this.things = {
            ripple: new RippleManagerClass(_target),
            miscparts:new PartsManagerClass(_target)
        }

        $(window).on("resize orientationchange",()=>{
            this.onResize();
        });
        $(window).on("scroll",()=>{
            this.onScroll();
        });
    }

    onCreate(){
        super.onCreate();
        for(let k in this.things) this.things[k].onCreate();
    }

    onLoad(){
        super.onLoad();
        for(let k in this.things) this.things[k].onLoad();
    }

    onResize(){
        super.onResize();

        let size = Util.getWindowSize();
        Util.windowSize = size;
        for(let k in this.things) this.things[k].onResize(size);
        this.onChangeBreakPointBefore(size);
        this.onScroll();
    }

    onChangeBreakPointBefore(_size){
        let b = (_size.w <= Util.BREAK_POINT);

        if(b !== this.isBreakpoint || this.isBreackPointCheckFirst){
            this.isVhChange = true;
            this.isBreackPointCheckFirst = false;
            Util.isBreakpoint = this.isBreakpoint = b;
            this.onChangeBreakPoint();
            for(let k in this.things) this.things[k].onChangeBreakPoint(b);
        }
    }

    onScroll(_st){
        super.onScroll();
        for(let k in this.things) this.things[k].onScroll(_st);
    }
}

